import {ChangeDetectionStrategy, InputSignal} from '@angular/core';
import {Component, input} from '@angular/core';
import {CheckBoxModule, SwitchModule} from "@syncfusion/ej2-angular-buttons";
import {TranslatePipe} from "../../pipes/translate.pipe";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-form-switch',
    imports: [
        SwitchModule,
        TranslatePipe,
        FormsModule,
        CheckBoxModule,
        ReactiveFormsModule
    ],
    templateUrl: './form-switch.component.html',
    styleUrl: './form-switch.component.scss'
})
export class FormSwitchComponent {
  public fCN: InputSignal<string> = input<string>('');
  public fG: InputSignal<FormGroup> = input<FormGroup>(new FormGroup({}));
  public onLabel: InputSignal<string> = input<string>('ON');
  public offLabel: InputSignal<string> = input<string>('OFF');
}
